import request from "@/utils/http"


export const getArticle = (lang) => {
  return request.get(`articles/featured-articles?lang=${lang}`)
}